import { render, staticRenderFns } from "./OfflineMessageForm.vue?vue&type=template&id=0c09d76a&scoped=true&"
import script from "./OfflineMessageForm.vue?vue&type=script&lang=js&"
export * from "./OfflineMessageForm.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0c09d76a",
  null
  ,true
)

export default component.exports